import { Component, OnInit } from '@angular/core';
import { OnboardingV2Service } from '@mpt-fo/common/core/services/onboarding-v2.service';

@Component({
  selector: 'app-sign-up-v3-header',
  templateUrl: './sign-up-v3-header.component.html',
  styleUrls: ['./sign-up-v3-header.component.scss']
})
export class SignUpV3HeaderComponent implements OnInit {

  constructor(public onboardingService: OnboardingV2Service) { }

  ngOnInit(): void {
  }

  goToLogin() {
		this.onboardingService.login();
	}

}
